import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { getAuthSnapshot } from '@/context/auth/deriveAuth';
import { useAuthContext } from '@/context/auth/useAuthContext';
import OrganizationViewingModeModal from '@/modules/super-admin/OrganizationViewingModeModal';
import { normalizeAuthRedirectLink } from '@/utils/authRedirectLink';

// Mounted here rather than in the _admin layout: super admin pages such as Users
// ('/') and Settings live directly under _authenticated.
const AuthenticatedLayout = () => {
  const { isSuperAdmin } = useAuthContext();

  return (
    <>
      <Outlet />
      {isSuperAdmin && <OrganizationViewingModeModal />}
    </>
  );
};

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
  validateSearch: (search: Record<string, unknown>) => {
    const link = normalizeAuthRedirectLink(search.link);
    if (link) {
      return {
        link,
      };
    }

    delete search.link;
    return {};
  },
  beforeLoad: async ({ location, search }) => {
    if (!getAuthSnapshot().isAuthenticated) {
      throw redirect({
        to: '/sign-in',
        search: { link: normalizeAuthRedirectLink(search.link) ?? location.href },
      });
    }
  },
});
